
import { useEffect } from 'react';

export const useShareTracking = () => {
  useEffect(() => {
    const trackShareClick = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const shareBy = urlParams.get('share_by');
      
      if (shareBy) {
        try {
          const response = await fetch(
            `https://cwuqmrrfvwddicutkrcc.supabase.co/functions/v1/track-share-click?share_by=${shareBy}`,
            {
              method: 'GET',
              headers: {
                'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN3dXFtcnJmdndkZGljdXRrcmNjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU0Mzc3OTEsImV4cCI6MjA2MTAxMzc5MX0.vnTSavxVDynyiZSltuaWBMuIKXLK_ZHCvBpHnz07R9Q'}`,
              },
            }
          );
          
          if (response.ok) {
            console.log('Share click tracked successfully');
          }
        } catch (error) {
          console.error('Error tracking share click:', error);
        }
      }
    };

    trackShareClick();
  }, []);
};
